export type TransactionTimelineRowProps = {
  key: string
  icon: React.ReactNode
  content: string | React.ReactNode
  meta: string | React.ReactNode
}

export const TransactionTimelineRow = ({
  row,
  index,
}: {
  row: TransactionTimelineRowProps
  index: number
}) => (
  <>
    {index > 0 && (
      <div
        className="flex w-4 items-center justify-center"
        key={`divider-txn-${index}`}
      >
        <div className="h-1.5 w-[1.5px] rounded-full bg-gray-300 dark:bg-gray-700" />
      </div>
    )}
    <div
      key={index}
      className="relative flex cursor-default items-center gap-2"
    >
      <div className="relative flex size-4 items-center justify-center">
        {row.icon}
      </div>
      <span className="flex h-6 min-w-0 flex-1 items-center gap-1 overflow-hidden whitespace-nowrap text-sm leading-6 text-secondary">
        {row.content}
      </span>
      <span className="flex-shrink-0 text-sm text-secondary">{row.meta}</span>
    </div>
  </>
)
